module.exports = __webpack_public_path__ + "img/fond_lard.2b0f3c3d.jpg";